export default {
  GENERAL: 'general',
  PARAMETERS: 'parameters',
};
